import moment from "moment";
import type { Company, Exam, Project } from "../api/dto";
import type { SelectedParticipantRow } from "../pages/BrowseAndFilterPage";

export function getOverallDataFileName(
  rows: SelectedParticipantRow[],
  company: Company,
  project: Project,
): string {
  let nameData: { slug: string; type: string } | null = null;
  let firstDate: Date | null = null;
  let lastDate: Date | null = null;
  for (const row of rows) {
    if (nameData === null) {
      const parts = /^(\d{4}-\d{2}-\d{2})_(\d{1,2}.\d{2}).+(\d+)_(\w+)-(Fct|Rct)$/.exec(
        row.exam.name ?? "",
      );
      const [, dateString, timeString, group, slug, type] = parts ?? [];
      if (slug && type) {
        nameData = { slug, type };
      }
    }
    if (firstDate === null || firstDate > row.exam.examAt) {
      firstDate = row.exam.examAt;
    }
    if (lastDate === null || lastDate < row.exam.examAt) {
      lastDate = row.exam.examAt;
    }
  }
  const projectName = formatProjectName(project);
  if (nameData === null || firstDate === null || lastDate === null) {
    return `${company.name} - ${projectName} - Overall Data.xlsx`;
  }
  return `${nameData.slug} - ${projectName} - ${moment(firstDate).format("YYYY-MM-DD")}_${moment(lastDate).format("YYYY-MM-DD")}-${nameData.type}.xlsx`;
}

export function getDashboardDataFileName(exams: Exam[], extension: string = "pdf"): string {
  let nameData: { slug: string; type: string } | null = null;
  let firstDate: Date | null = null;
  let lastDate: Date | null = null;
  for (const exam of exams) {
    if (nameData === null) {
      const parts = /^(\d{4}-\d{2}-\d{2})_(\d{1,2}.\d{2}).+(\d+)_(\w+)-(Fct|Rct)$/.exec(
        exam.name ?? "",
      );
      const [, dateString, timeString, group, slug, type] = parts ?? [];
      if (slug && type) {
        nameData = { slug, type };
      }
    }
    if (firstDate === null || firstDate > exam.examAt) {
      firstDate = exam.examAt;
    }
    if (lastDate === null || lastDate < exam.examAt) {
      lastDate = exam.examAt;
    }
  }
  let name = `Dashboard`;
  if (nameData?.slug) {
    name += `_${nameData?.slug}`;
  }
  if (moment(firstDate).format("YYYY-MM-DD") === moment(lastDate).format("YYYY-MM-DD")) {
    name += `_${moment(firstDate).format("YYYY-MM-DD")}`;
  } else {
    name += `_${moment(firstDate).format("YYYY-MM-DD")}_${moment(lastDate).format("YYYY-MM-DD")}`;
  }
  if (nameData) {
    name += `-${nameData.type}`;
  }
  return `${name}.${extension}`;
}

export function getDataReportDataFileName(exams: Exam[], extension: string = "pdf"): string {
  let nameData: { slug: string; type: string } | null = null;
  let firstDate: Date | null = null;
  let lastDate: Date | null = null;
  for (const exam of exams) {
    if (nameData === null) {
      const parts = /^(\d{4}-\d{2}-\d{2})_(\d{1,2}.\d{2}).+(\d+)_(\w+)-(Fct|Rct)$/.exec(
        exam.name ?? "",
      );
      const [, dateString, timeString, group, slug, type] = parts ?? [];
      if (slug && type) {
        nameData = { slug, type };
      }
    }
    if (firstDate === null || firstDate > exam.examAt) {
      firstDate = exam.examAt;
    }
    if (lastDate === null || lastDate < exam.examAt) {
      lastDate = exam.examAt;
    }
  }
  let name = `DataReport`;
  if (nameData?.slug) {
    name += `_${nameData?.slug}`;
  }
  if (moment(firstDate).format("YYYY-MM-DD") === moment(lastDate).format("YYYY-MM-DD")) {
    name += `_${moment(firstDate).format("YYYY-MM-DD")}`;
  } else {
    name += `_${moment(firstDate).format("YYYY-MM-DD")}_${moment(lastDate).format("YYYY-MM-DD")}`;
  }
  if (nameData) {
    name += `-${nameData.type}`;
  }
  return `${name}.${extension}`;
}

function formatProjectName(project: Project): string {
  return project.name
    .replace(/\s/g, "") // Remove spaces
    .replace(/\W/g, "_") // Replace non-word characters with '_'
    .replace(/_+/g, "_"); // Remove any duplicate '_' characters
}
